import { styled } from '@goodfynd/theme';
import { Link } from '@goodfynd/ui';

export const StyledDropdown = styled('ul', {
  display: 'none',
  listStyleType: 'none',
  padding: 0,
  margin: 0,
  '@lg': {
    display: 'initial',
  },
  variants: {
    variant: {
      horizontal: {
        display: 'flex',
        flexDirection: 'row',
      },
      vertical: {
        display: 'block',
      },
    },
  },
});

export const StyledNavLink = styled(Link, {
  paddingLeft: '8px !important',
  paddingRight: '8px !important',
  textTransform: 'none !important',
});
